import { IEventMetadata } from './event-schema.interface';

export interface IDeviceWithRoutePosition {
    traveledPath: string[];
    positions?: {
        lat: string;
        long: string;
        speed: number;
        timestamp: string;
        heading: number;
    }[];
}

export interface IDeviceWithRouteTrip {
    id?: string;
    code?: string;
    driverName?: string;
}

export interface IDeviceWithRouteSchema {
    deviceId: string;
    licensePlate?: string;
    maxSpeed: string;
    trip?: IDeviceWithRouteTrip;
    route: IDeviceWithRoutePosition;
    deviceDisplayName?: string;
    events?: {
        lat: string;
        lng: string;
        timestamp: string;
        eventType: string;
        eventData?: string;
        metadata?: IEventMetadata;
    }[];
}
